export default "__VITE_ASSET__DLrP4zNz__"